// const url = "https://api.xnserve.com/"; //正式环境
const url = "https://apitest.xnserve.com/"; //测试环境
const user = "user/";
export default {
  url,
  user,
};
